<mat-form-field class="mat-select-sm" appearance="fill">
    <mat-select [(ngModel)]="selectedValue" (ngModelChange)="valueChanged()">
        <mat-option *ngIf="allOption" value="All">All</mat-option>
        <mat-option *ngFor="let option of options | async" [value]="option.Value">
            {{option.Text}}
        </mat-option>
    </mat-select>
</mat-form-field>